import {createStore} from "vuex";
import {auth} from "./auth.module";
import {system} from "./setup.module";
import {loader} from "@/store/loader.module";
import {notification} from "@/store/notification.module";

const store = createStore({
    modules: {
        auth,
        system,
        loader,
        notification,
    },
    state: {
        message: '', // Initial empty message
    },
    mutations: {
        setMessage(state, message) {
            state.message = message;
        },
        clearMessage(state) {
            state.message = '';
        },
    },
});

export default store;
